module.exports = __webpack_public_path__ + "img/reduce_w.36461d60.svg";